import { instance } from '../../../../services/api';

// EU1832 - TO - 16/09/2022
export default (groupId: number, fileId: number) => {
    return instance.get(`/api/localGroupMemberDetails/${groupId}/${fileId}`);
};
